import { createSelector } from 'reselect'

import { getMoney } from '@cinch/oxd-redux/profile/src/selectors'

import { LifestyleData, LifestyleDomainReducer } from '../reducers/domain'

const getLifestyle = (state: { lifestyle: LifestyleDomainReducer }): LifestyleData => state.lifestyle.data

export default createSelector(getLifestyle, getMoney, (lifestyleData, budgetData) => ({
  ...lifestyleData,
  ...budgetData,
}))
